import React from "react";
import Avatar from "@mui/material/Avatar";
import { avatarType } from "@/store/slices/notifications/types";
import * as styles from "./style.module.scss";
import { getNameInitials } from "@/services/generic.methods";

const AvatarDefault = (props) => {
    const { src, name, icon, avatarClasses, avatarStyles } = props;
    const initials = getNameInitials(name);

    const generateColor = (initial) => {
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const index = alphabet?.indexOf(initial?.toUpperCase());
        const colors = [
          '#E893CF', '#9376E0', '#82B1FF', '#64B5F6', '#4FC3F7', '#4DD0E1',
          '#4DB6AC', '#81C784', '#AED581', '#DCE775', '#FFF176', '#FFD54F',
          '#FFB74D', '#FF8A65', '#FF7043', '#8D6E63', '#BDBDBD', '#78909C',
          '#CDDC39', '#FF5722', '#F44336', '#E53935', '#D32F2F', '#B71C1C',
          '#673AB7', '#3F51B5'
        ];
        const colorIndex = index < 0 ? 0 : index % colors.length;
        return colors[colorIndex];
      };

    const getContrastColor = (hexColor) => {
        // Convert hex color to RGB
        const hex = hexColor.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
      
        // Calculate color brightness
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      
        // Return contrasting text color based on brightness
        return brightness > 128 ? "#000000" : "#ffffff";
      };

    const bgColor = initials ? generateColor(initials?.charAt(0)) : null
    const textColor = initials ? getContrastColor(bgColor) : "#ffffff";

    return (
        (src ? <Avatar
            alt={name}
            src={src}
            className={`${styles.avatarCircleSize} ${avatarClasses}`}
            sx={avatarStyles}
        /> : <Avatar
                alt={name}
                className={`${styles.avatarCircleSize} ${avatarClasses}`}
                sx={{
                    backgroundColor: bgColor,
                    color: textColor,
                    borderColor: bgColor,
                    ...avatarStyles
                }}
            >
                {icon ? icon : initials}
            </Avatar>)
    );
};

export default AvatarDefault;
